<app-loader></app-loader>
<p-confirmPopup></p-confirmPopup>
<div class="add-information">
  <div class="add-heading" [ngClass]="{ 'table-space': !allGoVehicle?.length }">
    <h4>Add Equipment Information</h4>
    <div
      *ngIf="addButton"
      class="addmore-outer"
      (click)="openBookingDetail(null)"
    >
      <span>Add More</span>
      <img src="../../../../assets/images/add-icon.svg" alt="Add Icon" />
    </div>
  </div>

  <div class="add-truck">
    <div class="basic-information">
      <div
        class="custom-tabs"
        [ngClass]="{ 'table-card': allGoVehicle?.length }"
      >
        <div header="Header II">
          <div class="card veh-information">
            <form #vehicleForm="ngForm" novalidate>
              <p-table
                #dt
                [value]="allGoVehicle"
                dataKey="id"
                editMode="row"
                [tableStyle]="{ 'min-width': '50rem' }"
              >
                <ng-template
                  pTemplate="body"
                  let-product
                  let-editing="editing"
                  let-ri="rowIndex"
                >
                  <tr [pEditableRow]="product" class="bottim-spece">
                    <td class="vehicle-type">
                      <div class="vic-type custom-veh-img">
                        <img
                          alt="vehicleTypeImg"
                          [src]="
                            product.vehicleImage ||
                            product.vehicleType?.vehicleTypeImagePath
                          "
                        />
                        <div class="vic-text">
                          <p>{{ spotTypeMsg }}</p>
                          <div class="vehicle-outer">
                            <p-cellEditor>
                              <ng-template pTemplate="output">
                                <p class="truck-type">
                                  {{ product.vehicleType?.name }}
                                </p>
                              </ng-template>
                            </p-cellEditor>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">License Number</p>
                          <p-cellEditor>
                            <ng-template pTemplate="output">
                              <p class="truck-type">
                                {{ product.licenseNumberPlate }}
                              </p>
                            </ng-template>
                          </p-cellEditor>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">DOT Number</p>
                          <p-cellEditor>
                            <ng-template pTemplate="output">
                              <p class="truck-type">{{ product.dotNumber }}</p>
                            </ng-template>
                          </p-cellEditor>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">Trailer Number</p>
                          <p-cellEditor>
                            <ng-template pTemplate="output">
                              <p class="truck-type">
                                {{ product.trailerNumber }}
                              </p>
                            </ng-template>
                          </p-cellEditor>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">Company Name</p>
                          <p-cellEditor>
                            <ng-template pTemplate="output">
                              <p class="truck-type">
                                {{ product.companyName }}
                              </p>
                            </ng-template>
                          </p-cellEditor>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">Make</p>
                          <div class="common-width">
                            <p-cellEditor>
                              <ng-template pTemplate="output">
                                <p class="truck-type">
                                  {{ product.make || "&nbsp;" }}
                                </p>
                              </ng-template>
                            </p-cellEditor>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="vic-type1">
                        <div class="vic-text">
                          <p class="custom-label">Color</p>
                          <div class="common-width">
                            <p-cellEditor>
                              <ng-template pTemplate="output">
                                <p class="truck-type">
                                  {{ product.color || "&nbsp;" }}
                                </p>
                              </ng-template>
                            </p-cellEditor>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="action-item">
                        <div>
                          <img
                            (click)="
                              showData(product, $event);
                              vehicleMenu.toggle($event)
                            "
                            src="assets/images/dashboard-dot.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="custom-export">
  <p-menu #vehicleMenu [model]="items" [popup]="true"></p-menu>
</div>
